/**
 * @overview 知识库编辑
 * @author
 * @date
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool'
let { WizContainer, WizAvatarUpload, modelUtils, ossFileUtils } = framework_tool;
let { WizCard, WizInput, WizForm, Wizmessage, WizTooltip, WizIcon, WizRow, WizCol, WizButton, WizTabs,WizDataTable,WizSpin,WizBraftEditor,WizModal,WizTable } = component_tool;
let { TabPane } = WizTabs
let { Session,getPageData } = utils_tool;
import { Spin,Descriptions } from 'antd'
import '@/styles/containers/proKnowledge/knowledgeBaseList/style.less'
import { WizAuthority,WizBraftEditorPlus } from "../../../../common";
import { formatAuth } from '@/utils/commonUtils'

import KnowledgeBaseForm from './knowledgeBaseForm'
import Item from 'antd/lib/list/Item';
import NewVersion from './../newVersion'

class KnowledgeBaseLook extends WizContainer {

  componentName = 'knowledgeBaseLook';

  constructor(props) {
    super(props);
    const { history } = props;
    let initialValue = {};
    let knowledgeTypeId = null;
    let knowledgeId = null;
    if (history.location && history.location.pathname === '/proKnowledge/knowledgeBaseList/knowledgeBaseDetailLook') {
      if (history.location.record) {
        knowledgeId = history.location.record.id
        knowledgeTypeId = history.location.record.proKnowledgeTypeId
        Session.set('knowledgeTypeId', knowledgeTypeId)
        Session.set('knowledgeId', knowledgeId)
      } else {
        knowledgeId = Session.get('knowledgeId');
        initialValue = Session.get('proKnowledgeInfo')
        knowledgeTypeId = Session.get('knowledgeTypeId') || undefined;
      }
    }
    this.state = {
      versionListInfo: [],
      changeListInfo: [],
      proKnowledgeTypeInfo: {},
      showVersionModal:false,
      businessListInfo:[],
    }
    this.initialValue = initialValue;
    this.knowledgeId = knowledgeId;
    this.knowledgeTypeId = knowledgeTypeId;
  }

  _componentDidMount() {
    const { history } = this.props;
    this.getProKnowledgeById(this.knowledgeId);
    this.getVersionList();
    this.getChangeList();
    this.getProKnowledgeType(this.knowledgeTypeId)
    this.getBusinessList();
  }

  getVersionList(apiParams = {}) {
    this.doAction({
      path: 'proKnowledge/getVersionList',
      payload: {
        key: 'proKnowledge@getVersionList',
        apiParams: {
          id: this.knowledgeId,
          ...apiParams
        }
      }
    })
  }

  getChangeList(apiParams = {}) {
    this.doAction({
      path: 'proKnowledge/getChangeList',
      payload: {
        key: 'proKnowledge@getChangeList',
        apiParams: {
          id: this.knowledgeId,
          ...apiParams
        }
      }
    })
  }

  getProKnowledgeType(id) {
    this.doAction(
      {
        path: 'proKnowledgeType/getOneById',
        payload: {
          key: 'proKnowledgeType@getOneById',
          apiParams: {
            id: id
          }
        },
        requireLoading: true,
      }
    )
  }

  getProKnowledgeById(id) {
    this.doAction({
      path: 'proKnowledge/getProKnowledgeById',
      payload: {
        key: 'proKnowledge@getProKnowledgeById',
        apiParams: {
          id: id,
        }
      }
    })
  }

  getBusinessList(apiParams = {}) {
    this.doAction({
      path: 'proKnowledge/getBusinessList',
      payload: {
        key: 'proKnowledge@getBusinessList',
        apiParams: {
          id: this.knowledgeId,
          ...apiParams
        }
      }
    })
  }

  propsAndStateOnChange = {
    versionList: this._versionListOver.bind(this),
    changeList: this._changeListOver.bind(this),
    proKnowledgeInfo: this._proKnowledgeInfoOver.bind(this),
    proKnowledgeTypeInfo: this._proKnowledgeTypeInfoOver.bind(this),
    businessList: this._businessListOver.bind(this),
  }

  _proKnowledgeTypeInfoOver(nextProps, nextState) {
    if (nextProps.proKnowledgeTypeInfo.code == 1) {
      let proKnowledgeTypeInfo = nextProps.proKnowledgeTypeInfo.data
      nextState['proKnowledgeTypeInfo'] = proKnowledgeTypeInfo
    } else {
      wizNotice.error('操作失败：' + nextProps.proKnowledgeTypeInfo.msg);
    }
    return true;
  }

  _versionListOver(nextProps, nextState) {
    if (nextProps.versionList.code == 1) {
      let versionListInfo = nextProps.versionList.data
      nextState['versionListInfo'] = versionListInfo
    } else {
      wizNotice.error('操作失败：' + nextProps.versionList.msg);
    }
    return true;
  }

  _changeListOver(nextProps, nextState) {
    if (nextProps.changeList.code == 1) {
      let changeListInfo = nextProps.changeList.data
      nextState['changeListInfo'] = changeListInfo
    } else {
      wizNotice.error('操作失败：' + nextProps.versionList.msg);
    }
    return true;
  }

  _proKnowledgeInfoOver(nextProps, nextState) {
    if (nextProps.proKnowledgeInfo.code == 1) {
      let proKnowledgeInfo = nextProps.proKnowledgeInfo.data
      this.initialValue = proKnowledgeInfo;
      Session.set('proKnowledgeInfo', proKnowledgeInfo)
    } else {
      wizNotice.error('操作失败：' + nextProps.proKnowledgeInfo.msg);
    }
    return true;
  }

  _businessListOver(nextProps, nextState) {
    if (nextProps.businessList.code == 1) {
      let businessListInfo = nextProps.businessList.data
      nextState['businessListInfo'] = businessListInfo
    } else {
      wizNotice.error('操作失败：' + nextProps.businessList.msg);
    }
    return true;
  }

  _onSubmit(type){
    if(type==1){
      this.setState({
        showVersionModal:true
      })
    }else{
      this.jumpPage('replace','/proKnowledge/knowledgeBaseList/knowledgeBaseDetailUpd',{...this.initialValue})
    }
  }

  _getHeadInfo() {
    let btns =
      [<WizButton htmlType="submit" onClick={e => this._onSubmit(1)}>
        新版本
      </WizButton>,
      <WizButton className="btn-info" htmlType="submit" onClick={e => this._onSubmit(2)}>
        编辑
      </WizButton>]
    return (
      <WizRow className='knowledge-div-button' gutter={[8, 16]}>
        <WizCol>
          <WizRow className='knowledge-row' align={'middle'} justify={'center'} >
            <WizCol offset={20}>
              <WizButton.WizGroup className={'knowledge-group-button'}>
                {btns}
              </WizButton.WizGroup>
            </WizCol>
          </WizRow>
        </WizCol>
      </WizRow>
    )
  }

  _getLeftBodyInfo() {
    let propertyList = this.state.proKnowledgeTypeInfo.propertyList;
    let src= this.initialValue.img ? getOssFilePath(this.initialValue.img) : constants.files.sys_proKnowledge_default_image
    let items = [

    ]
    if (propertyList && propertyList.length) {
      propertyList.forEach(element => {
        let value = "";
        switch (element.code) {
          case "img":
            value = <img hight={'150px'} width={'300px'} src={src} />
            break;
          case "authorType":
            value = this.initialValue.authorTypeStr
            break;
          case "author":
            value = this.initialValue.author
            break;
          case "authorIntro":
            value = this.initialValue.authorIntro
            break;
          case "belongOrg":
            value = this.initialValue.belongOrg
            break;
          case "category":
            value = this.initialValue.categoryStr
            break;
          case "label":
            value = this.initialValue.labelStr
            break;
          case "startTime":
            value = this.initialValue.effectiveTime
            break;
          case "endTime":
            value = this.initialValue.failureTime
            break;
          default:
            break
        }
        let item =element.name=='封面'? {
          name: element.code,
          formItem: {
            type: 'custom',
            formItemLayout: {
              wrapperCol: { span: 24 }
            },
            render: () => {
              return <div className='knowledge-col-img'>{value || ""}</div>}
          },
        } :{
          title: element.name,
          name: element.code,
          formItem: {
            type: 'custom',
            render: () => {
              return <div>{value || ""}</div>}
          },
        };
        items.push(item);
        if (element.code == 'belongOrg') {
          items.push({
            title: "品牌",
            formItem: {
              type: 'custom',
              render: () => {
                return <div>{this.initialValue.brandName || ""}</div>}
            },
          });
          items.push({
            title: "功能块",
            formItem: {
              type: 'custom',
              render: () => {
                let dict =[
                  { code: 0, codeName: "销售" },
                  { code: 1, codeName: "售后服务" },
                  { code: 2, codeName: "售后技术" },
                  { code: 3, codeName: "诚新二手车" },
                  { code: 4, codeName: "校企合作" },
                  { code: 5, codeName: "集团销售" },
                  { code: 9, codeName: "跨业务块" },
                ]
                let moduleName = "";
                dict.forEach(e=>{
                  if(e.code==this.initialValue.module){
                    moduleName = e.codeName;
                  }
                })
                return <div>{moduleName}</div>}
            },
          });


          items.push({
            title: "知识类型",
            formItem: {
              type: 'custom',
              render: () => {
                return <div>{this.initialValue.proKnowledgeTypeTitle || ""}</div>}
            },
          });
        }
      })
    }
    return items;
  }

  _createIntro=(requirement)=>{
    if (requirement && document.getElementById("knowledge_intro") != null) {
      document.getElementById(
        "knowledge_intro"
      ).innerHTML = WizBraftEditor.createEditorState(requirement).toHTML();
    }
  }

  _getRightBodyInfo() {
    let fileObj = this.initialValue.fileInfo && this.initialValue.fileInfo.length ? this.initialValue.fileInfo[0] :{}
    let {fileName,fileId} = fileObj;
    let fileInfo="";
    if(fileName && fileId){
      fileInfo =  <WizCol span={24} ><div height={80} width={130} style={{marginLeft:"10px"}} >
      <a href={getOssFilePath(fileId)} target="_blank" style={{color: "blue"}}>{fileName}</a>
      </div></WizCol>
    }
    let items = [
      {
        title: "标题",
        name: 'title',
        formItem: {
          type: 'custom',
          render: () => {
            return <div>{this.initialValue.title || ""}</div>}
        },
      },
      {
        title: "摘要",
        name: 'intro',
        formItem: {
          type: 'custom',
          render: () => {
            return <div>{this.initialValue.intro || ""}</div>}
        },
      },
      {
        title: "知识",
        name: 'fileName',
        formItem: {
          type: 'custom',
          render: () => {
            return <><div>{fileInfo || ""}</div>
            <div id='knowledge_intro'> {this._createIntro(this.initialValue.textContent)} </div>
            </>
          }
        },
      },
      // {
      //   title: "富文本",
      //   name: 'textContent',
      //   formItem: {
      //     type: 'custom',
      //     render: () => {
      //       return <div id='knowledge_intro'> {this._createIntro(this.initialValue.textContent)} </div>
      //     },
      //   }
      // }
    ]
    return items;
  }

  authorityInfo = (data) => {
    return (
      <WizAuthority value={data} mode='Show' showBlock={false} />
    )
  }

  _highSet() {
    let items = [
      <Descriptions.Item label='发布终端'>{this.initialValue.releasePlatformStr}</Descriptions.Item>,
      <Descriptions.Item label='添加水印'>{this.initialValue.watermarkStr}</Descriptions.Item>,
      <Descriptions.Item label='是否允许下载'>{this.initialValue.downloadStr}</Descriptions.Item>,
      <Descriptions.Item label='点赞'>{this.initialValue.switchLikeStr}</Descriptions.Item>,
      <Descriptions.Item label='评论'>{this.initialValue.switchCommentStr}</Descriptions.Item>,
      <Descriptions.Item label='受众'>{this.authorityInfo(this.initialValue.authInfo)}</Descriptions.Item>,
    ]
    let info =  <Descriptions column={1}  bordered={true}>{items}</Descriptions>
    return info
  }

  _getVersionListInfo() {
    let columns = [
      {
        title: "序号",
        name: "no",
        dataIndex: "no",
        tableItem: {},
      },
      {
        title: "标题",
        name: "title",
        dataIndex: "title",
        tableItem: {},
      },
      {
        title: "知识类型",
        name: "proKnowledgeType",
        dataIndex: "proKnowledgeType",
        tableItem: {},
      },
      {
        title: "创建人",
        name: "createBy",
        dataIndex: "createBy",
        tableItem: {},
      },
      {
        title: "版本号",
        name: "version",
        dataIndex: "version",
        tableItem: {},
      },
      {
        title: "创建时间",
        name: "createTime",
        dataIndex: "createTime",
        tableItem: {},
      },
    ]
    const dataItems = getPageData(this.state.versionListInfo);
    const { history,proKnowledgeLoading } = this.props;
    let dataTableProps = {
      loading: proKnowledgeLoading,
      columns,
      rowKey: 'id',
      dataItems: dataItems,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        this.getVersionList({ current: pageNum, size: pageSize })
      },
      showNum: false,
    }
    return <WizSpin tip={'加载中'} spinning={proKnowledgeLoading}>
      <div style={{marginBottom:'15px'}}><strong><font>当前版本</font><font style={{marginLeft:"20px"}}>{this.initialValue.version ? this.initialValue.version :"V1.0" } </font></strong></div>
      <WizDataTable key={'VersionList_dataTable1'} {...dataTableProps} />
      <div className='pagination'>
        <WizDataTable.Pagination key={'VersionList_dataTable2'} {...dataTableProps} />
      </div>
    </WizSpin>
  }

  _getChangeListInfo() {
    let columns = [
      {
        title: "序号",
        name: "no",
        dataIndex: "no",
        tableItem: {},
      },
      {
        title: "变更人",
        name: "fullName",
        dataIndex: "fullName",
        tableItem: {},
      },
      {
        title: "账号",
        name: "userName",
        dataIndex: "userName",
        tableItem: {},
      },
      {
        title: "变更时间",
        name: "time",
        dataIndex: "time",
        tableItem: {},
      },
    ]
    const dataItems = getPageData(this.state.changeListInfo);
    const { history,proKnowledgeLoading } = this.props;
    let dataTableProps = {
      loading: proKnowledgeLoading,
      columns,
      rowKey: 'id',
      dataItems: dataItems,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        this.getChangeList({ current: pageNum, size: pageSize })
      },
      showNum: false,
    }
    return <WizSpin tip={'加载中'} spinning={proKnowledgeLoading}>
       <div style={{marginBottom:'15px'}}><strong><font>当前版本</font><font style={{marginLeft:"20px"}}>{this.initialValue.version ? this.initialValue.version :"V1.0" } </font></strong></div>
      <WizDataTable key={'ChangeList_dataTable1'} {...dataTableProps} />
      <div className='pagination'>
        <WizDataTable.Pagination key={'ChangeList_dataTable2'} {...dataTableProps} />
      </div>
    </WizSpin>
  }

  _getBusinessListInfo() {
    let columns = [
      {
        title: "业务类型",
        name: "typeStr",
        dataIndex: "typeStr",
        tableItem: {},
      },
      {
        title: "业务名称",
        name: "entityName",
        dataIndex: "entityName",
        tableItem: {},
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 160,
        render: (text, record) => (
          <span>
            <a onClick={e => this.jumpPage('push', '/program/programList/programDetailShow',{id:record.entityId}) }>查看</a>
          </span>
        ),
      },
    ]

    return <WizSpin tip={'加载中'} spinning={this.props.proKnowledgeLoading}>
      <WizTable style={{marginTop:'15px'}} pagination={false} columns={columns} dataSource={this.state.businessListInfo}/>
    </WizSpin>
  }

  _getTabs() {
    const { proKnowledgeTypeInfo } = this.state
    let contentType = proKnowledgeTypeInfo.contentType;
    let businessListInfo = undefined
    if (contentType && contentType.indexOf("3") != -1) {
      businessListInfo = <TabPane tab="关联业务" key="4" >
      {this._getBusinessListInfo()}
    </TabPane>
    }
    return <WizTabs defaultActiveKey={"1"} tabBarStyle={{  backgroundColor: 'rgb(247, 247, 247)'}} animated={false}>
      <TabPane tab="高级设置" key="1" >
        {this._highSet()}
      </TabPane>
     {businessListInfo}
      <TabPane tab="版本" key="2" >
        {this._getVersionListInfo()}
      </TabPane>
      <TabPane tab="变更记录" key="3" >
        {this._getChangeListInfo()}
      </TabPane>
    </WizTabs>
  }

  _formProps(type){
    let columns;
    let formItemLayout;
    if(type=='left'){
      columns = this._getLeftBodyInfo();
      formItemLayout = {
        labelCol: {span: 6},
        wrapperCol: {span: 14}
      }
    }else{
      columns = this._getRightBodyInfo()
      formItemLayout = {
        labelCol: {span: 4},
        wrapperCol: {span: 20}
      }
    }
    let formProps = {
      ref: 'form',
      columns ,
      record: null,
      preview: null,
      footer: null,
      formItemLayout,
      style: {maxWidth: 800}
    };
    return formProps;
  }

  _render() {
    const { history,proKnowledgeLoading } = this.props;
    let cardProps = {
      headStyle: {backgroundColor: '#ffffff', color: '#3a3a3a'},
      bordered: true,
      bodyStyle: {minHeight: '850px',marginTop:'25px'}
    }
    return (
      <div>
      <Spin tip={'加载中'} spinning={proKnowledgeLoading}>
        <div className='knowledge-info'>
          {this._getHeadInfo()}
          <WizRow className='knowledge-div-row' gutter={[8, 16]}>
            <WizCol span={8} className='knowledge-col'>
              <WizCard {...cardProps} >
                <WizForm className={'form-inline'} {...this._formProps('left')}  />
              </WizCard>
            </WizCol>
            <WizCol span={16} className='knowledge-col'>
              <WizCard {...cardProps} >
                <WizForm className={'form-inline'} {...this._formProps('right')}  />
                {this._getTabs()}
              </WizCard>
            </WizCol>
          </WizRow>
          <WizModal
            visible={this.state.showVersionModal}
            cancelButtonProps={{ style: { height: 0, width: 0 } }}
            style={{ minWidth: 400 }}
            title='请选择知识点版本号'
            onCancel={() => this.setState({ showVersionModal: false })}
            footer={null}
          >
            <NewVersion record={this.initialValue}/>
          </WizModal>
        </div>
      </Spin>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { proKnowledge, proKnowledgeType } = state;
  const versionList = modelUtils.getModelEntity(proKnowledge, "proKnowledge@getVersionList");
  const changeList = modelUtils.getModelEntity(proKnowledge, "proKnowledge@getChangeList");
  const proKnowledgeInfo = modelUtils.getModelEntity(proKnowledge, "proKnowledge@getProKnowledgeById");
  const proKnowledgeTypeInfo = modelUtils.getModelEntity(proKnowledgeType, "proKnowledgeType@getOneById");
  const businessList = modelUtils.getModelEntity(proKnowledge, "proKnowledge@getBusinessList");
  const load = modelUtils.getLoadingState(state, ['proKnowledge']);
  return {
    versionList,
    changeList,
    proKnowledgeInfo,
    proKnowledgeTypeInfo,
    businessList,
    ...load
  }
};

export default connect(mapStateToProps)(KnowledgeBaseLook);
